import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-031458f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TenanDataBox" }
const _hoisted_2 = { class: "operationCont" }
const _hoisted_3 = { class: "TenanDataBox-table" }
const _hoisted_4 = { class: "paginationCont" }
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = { class: "form-div" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"blue","text-align":"center"} }, " 承保验标采集配置 ", -1))
const _hoisted_8 = { style: {"color":"blue"} }
const _hoisted_9 = { style: {"color":"blue"} }
const _hoisted_10 = { class: "form-div" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"blue","text-align":"center"} }, " 理赔验标采集配置 ", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"color":"blue"} }
const _hoisted_14 = { style: {"color":"blue"} }
const _hoisted_15 = { class: "flex mb-10" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "启用大模型：")
], -1))
const _hoisted_17 = { class: "select-model" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "调用模型：", -1))
const _hoisted_19 = { class: "flex mb-10" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "大模型调用区间：")
], -1))
const _hoisted_21 = { class: "flex1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative-2" }, "公司模型相似度", -1))
const _hoisted_23 = { class: "flex mb-10 align-start" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "调用提示词：")
], -1))
const _hoisted_25 = { class: "flex1" }
const _hoisted_26 = { class: "flex align-start" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right calc-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最终相似度计算：")
], -1))
const _hoisted_28 = { class: "flex1" }
const _hoisted_29 = { class: "mb-10 flex calc" }
const _hoisted_30 = { class: "flex1" }
const _hoisted_31 = { class: "relative-2" }
const _hoisted_32 = { class: "flex calc mb-10" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formula text-center" }, "公式：", -1))
const _hoisted_34 = { class: "flex1" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative-2" }, "模型相似度  ×  ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative-2" }, "  + 公司模型相似度  ×  ", -1))
const _hoisted_37 = { class: "flex mb-10" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "启用大模型：")
], -1))
const _hoisted_39 = { class: "select-model" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "调用模型：", -1))
const _hoisted_41 = { class: "flex mb-10" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "大模型调用区间：")
], -1))
const _hoisted_43 = { class: "flex1" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative-2" }, "公司模型相似度", -1))
const _hoisted_45 = { class: "flex mb-10 align-start" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right" }, [
  /*#__PURE__*/_createElementVNode("span", null, "调用提示词：")
], -1))
const _hoisted_47 = { class: "flex1" }
const _hoisted_48 = { class: "flex align-start" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-20 flex-right calc-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最终相似度计算：")
], -1))
const _hoisted_50 = { class: "flex1" }
const _hoisted_51 = { class: "mb-10 flex calc" }
const _hoisted_52 = { class: "flex1" }
const _hoisted_53 = { class: "relative-2" }
const _hoisted_54 = { class: "flex calc mb-10" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "formula text-center" }, "公式：", -1))
const _hoisted_56 = { class: "flex1" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative-2" }, "模型相似度  ×  ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "relative-2" }, "  + 公司模型相似度  ×  ", -1))
const _hoisted_59 = { class: "push-config-container" }
const _hoisted_60 = { class: "push-section" }
const _hoisted_61 = { class: "section-header" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "承保验标推送信息", -1))
const _hoisted_63 = { class: "push-content-wrapper" }
const _hoisted_64 = {
  key: 0,
  class: "push-item"
}
const _hoisted_65 = {
  key: 1,
  class: "no-options-hint"
}
const _hoisted_66 = { class: "push-range config-section" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "推送范围", -1))
const _hoisted_68 = { class: "photo-method config-section" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "照片方式", -1))
const _hoisted_70 = {
  class: "push-section",
  style: {"margin-top":"20px"}
}
const _hoisted_71 = { class: "section-header" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "理赔案件推送信息", -1))
const _hoisted_73 = { class: "push-content-wrapper" }
const _hoisted_74 = {
  key: 0,
  class: "push-item"
}
const _hoisted_75 = {
  key: 1,
  class: "no-options-hint"
}
const _hoisted_76 = { class: "push-range config-section" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "推送范围", -1))
const _hoisted_78 = { class: "photo-method config-section" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "照片方式", -1))
const _hoisted_80 = { class: "watermark-config-container" }
const _hoisted_81 = { class: "watermark-section" }
const _hoisted_82 = { class: "section-header" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "承保验标照片水印 ", -1))
const _hoisted_84 = {
  class: "watermark-options",
  style: {"display":"flex"}
}
const _hoisted_85 = { class: "option-row" }
const _hoisted_86 = { class: "option-row" }
const _hoisted_87 = { class: "option-row" }
const _hoisted_88 = { class: "option-row" }
const _hoisted_89 = { class: "watermark-section" }
const _hoisted_90 = { class: "section-header" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "section-title" }, "理赔验标水印", -1))
const _hoisted_92 = { class: "watermark-options" }
const _hoisted_93 = { class: "option-row" }
const _hoisted_94 = { class: "option-row" }
const _hoisted_95 = { class: "option-row" }
const _hoisted_96 = { class: "option-row" }
const _hoisted_97 = { class: "option-row" }
const _hoisted_98 = { class: "dialog-footer" }
const _hoisted_99 = { class: "dialog-image" }
const _hoisted_100 = ["src"]

import { useRouter } from "vue-router";
import { ElMessage, FormRules, FormInstance, UploadProps } from "element-plus";
import type { TabsPaneContext } from "element-plus";

import {
  ref,
  reactive,
  onMounted,
  getCurrentInstance,
  toRaw,
  watch,
  nextTick,
  onUnmounted,
  computed,
} from "vue";
import {
  getTenanpageList,
  changeEnable,
  addCompanyInfo,
  updateCompanyInfo,
  getCompanyOption,
  updateCompanyOption,
} from "./api.js";
import { v4 as uuidv4 } from "uuid";
import { getTencentCloudConfig } from "@/views/VerificationData/api.js";

import { setField } from "../../utiles/utiles";
import { Search, RefreshRight } from "@element-plus/icons-vue";
import { cloneDeep, range } from "lodash";
interface ruleFormConfigItem {
  id: string;
  farmerName: string;
  deptName: string;
  certificateType: string;
  phone: string;
  idCard: string;
  addr: string;
  url: string | null;
}

interface allFormItem {
  insureForm: InsureForm;
  paymentForm: PaymentForm;
  idCardVerification: number;
  phoneNumberVerification: number;
  showRepeatTarget: number;
  allowRepeatBatchAudit: number;
  enableFuzzyCheck: number;
  verifyTargetOrCollar: string[];
  earTagGenerator: string | null;
}
interface InsureForm {
  id: string;
  compCode: string;
  comparisonRangeObj: object;
  scoreObjList: object[];
  acquisitionTypeList: string[];
  sourceTypeList: string[];
  selectedConfigs: string[];
  selectedfields: string[];
  acquisitionOptions: object[];
  collectFields:object[];
  enableAutoCheck: number;
  idCardVerification?: number;
  phoneNumberVerification?: number;
}
interface PaymentForm {
  id: string;
  compCode: string;
  comparisonRangeObj: object;
  scoreObjList: object[];
  acquisitionTypeList: string[];
  sourceTypeList: string[];
  selectedConfigs: string[];
  
  selectedfields: string[];
  acquisitionOptions: object[];
  collectFields:object[];
  idCardVerification: number;
  phoneNumberVerification: number;
}
interface CompanyOptionDTO {
  typeEnum: string;
  companyOptionObj: {
    acquisitionOptions: Array<{
      picTypeEnum: string;
      shotNum: number;
      defaultScore: number;
      minScore: number;
      degression: number;
    }>;
    collectFields: Array<{
      field: string;
      isRequired: string;
    }>;
    idCardVerification?: number;
    phoneNumberVerification?: number;
    // ... other properties of InsureForm and PaymentForm
  };
  compCode: string;
  id: string;
}
enum PicTypeEnum {
  FACE = "FACE",
  NOSE = "NOSE",
  LEFT_FACE = "LEFT_FACE",
  RIGHT_FACE = "RIGHT_FACE",
  PIG_FACE = "PIG_FACE",
  PIG_BODY = "PIG_BODY",
}

// 创建一个映射对象，用于将枚举值转换为显示文本
type modelCalc = {
  largeModelSimilarity: number;
  largeModelSimilarityProp: number;
  companySimilarityProp: number;
};
// 模型配置
interface IModelConfig {
  [key: string]: any;
  id: string;
  compCode?: string;
  configType: string;
  isEnabled: number;
  invokeModel: string;
  companySimilarityPre: number;
  companySimilarityPost: number;
  modelPromptWord: string;
  largeModelConditions: modelCalc[];
}

// 活活对比
interface PushDataConfig {
  id?: number;
  compCode: string;
  apiValue: string;
  apiName: string;
  apiUrl: string;
  apiType: 'INSURANCE' | 'CLAIM';
  enable: string;
  targetRange: 'NORMAL' | 'REPEAT' | 'ALL';
  modeList: string[];
  modes: string;
}

// 定义推送配置状态类型
interface PushConfigState {
  enable: string;
  apiValue: string;
  apiName: string;
  apiUrl: string;
  targetRange: 'NORMAL' | 'REPEAT' | 'ALL';
  modeList: string[];
  modeOptions: Array<{ label: string; value: number }>;
  targetRangeOptions: Array<{ label: string; value: 'NORMAL' | 'REPEAT' | 'ALL' }>;
}

// 承保验标推送配置

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ruleFormRef = ref<FormInstance>();
const ruleFormRefBox = ref<FormInstance>();
const ruleFormRefAll = ref<FormInstance>();
const Router = useRouter();
const validatePhone = (rule: any, value: any, callback: any) => {
  if (value) {
    let reg = new RegExp(/^1[3456789]\d{9}$/);
    if (!reg.test(value)) {
      callback("请录入正确的联系电话");
    } else {
      callback();
    }
  } else {
    callback();
  }
};
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }

  const tableContainer = document.querySelector(".TenanDataBox-table");
  if (!tableContainer) {
    console.log("未找到表格容器");
    return;
  }

  const allRows = document.querySelectorAll(".el-table__row");
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector(".el-table__header");
  const headerHeight = tableHeader
    ? tableHeader.getBoundingClientRect().height
    : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return; // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
const queryForm = reactive({
  condition: {
    compCode: "",
    compName: "",
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});
const getYes = 1;
const getNo = 0;

const eartag = "EAR_TAG";
const collar = "COLLAR";
const never = "NONE";
const externalEarTag = "EXTERNAL_EAR_TAG";

const timestamp = "TIME_STAMP";
const deptCode = "DEPT_CODE";

function initializeAllForm() {
  return reactive<allFormItem>({
    insureForm: {
      id: "",
      compCode: "",
      comparisonRangeObj: {
        comparisonRange: "CURRENT_ORDER_INSURE", // 这里可以是 '1' 或 '2'，表示默认选中的单选按钮
        level: 0, // 这里是数字输入框的默认值
      },
      scoreObjList: [{ score: 85, typeEnum: "INSURANCE" }],
      acquisitionTypeList: ["REAL_TIME_RECOGNITION"],
      sourceTypeList: ["APP_CREATE"],
      // selectedConfigs: ["FACE", "PIG_FACE", "NOSE"],
      selectedConfigs: [],
      
      selectedfields: [],
      acquisitionOptions: [
        {
          picTypeEnum: "FACE",
          label: "正脸",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
        {
          picTypeEnum: "LEFT_FACE",
          label: "左侧脸",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
        {
          picTypeEnum: "RIGHT_FACE",
          label: "右侧脸",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
        {
          picTypeEnum: "NOSE",
          label: "鼻纹",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
      ],
      collectFields:[{
        field: "LIVESTOCK_AGE",
        isRequired: '1',
      }],
      enableAutoCheck: 1,
      idCardVerification: 1,
      phoneNumberVerification: 1,
    },
    paymentForm: {
      id: "",
      compCode: "",
      comparisonRangeObj: {
        comparisonRange: "CURRENT_FARMER_CLAIM",
        level: 0, // 这里是数字输入框的默认值
      },
      scoreObjList: [
        { score: 85, typeEnum: "INSURANCE" },
        { score: 85, typeEnum: "CLAIM" },
      ],
      acquisitionTypeList: ["TAKE_PHOTO"],
      sourceTypeList: ["SYSTEM_INTERGRATION_CREATE"],
      // selectedConfigs: ["FACE", "PIG_FACE", "NOSE"], // 存储选中的配置类型
      selectedConfigs: [],
      selectedfields:[],
      acquisitionOptions: [
        {
          picTypeEnum: "FACE",
          label: "正脸",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
        {
          picTypeEnum: "LEFT_FACE",
          label: "左侧脸",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
        {
          picTypeEnum: "RIGHT_FACE",
          label: "右侧脸",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
        {
          picTypeEnum: "NOSE",
          label: "鼻纹",
          color: "blue",
          shotNum: 3,
          defaultScore: 80,
          minScore: 70,
          degression: 5,
        },
      ],
      collectFields:[{
        field: "LIVESTOCK_AGE",
        isRequired:  '1',
      }],
      idCardVerification: 1,
      phoneNumberVerification: 1,
    },
    idCardVerification: 1,
    phoneNumberVerification: 1,
    showRepeatTarget: 1,
    allowRepeatBatchAudit: 0,
    enableFuzzyCheck: 1,
    verifyTargetOrCollar: [],
    earTagGenerator: null,
  });
}

let allForm = reactive<allFormItem>({
  insureForm: {
    id: "",
    compCode: "",
    comparisonRangeObj: {
      comparisonRange: "CURRENT_ORDER_INSURE", // 这里可以是 '1' 或 '2'，表示默认选中的单选按钮
      level: 0, // 这里是数字输入框的默认值
    },
    scoreObjList: [{ score: 85, typeEnum: "INSURANCE" }],
    acquisitionTypeList: ["REAL_TIME_RECOGNITION"],
    sourceTypeList: ["APP_CREATE"],
    // selectedConfigs: ["FACE", "PIG_FACE", "NOSE"],
    selectedConfigs: [],
    selectedfields:[],
    acquisitionOptions: [
      {
        picTypeEnum: "FACE",
        label: "正脸",
        color: "blue",
        shotNum: 3,
        defaultScore: 80,
        minScore: 70,
        degression: 5,
      },
      {
        picTypeEnum: "PIG_FACE",
        label: "侧脸",
        color: "blue",
        shotNum: 3,
        defaultScore: 80,
        minScore: 70,
        degression: 5,
      },
      {
        picTypeEnum: "NOSE",
        label: "鼻纹",
        color: "blue",
        shotNum: 3,
        defaultScore: 80,
        minScore: 70,
        degression: 5,
      },
    ],
    collectFields:[{
      field: "LIVESTOCK_AGE",
      isRequired:  '1',
    }],
    enableAutoCheck: 1,
    idCardVerification: 1,
    phoneNumberVerification: 1,
  },
  paymentForm: {
    id: "",
    compCode: "",
    comparisonRangeObj: {
      comparisonRange: "CURRENT_FARMER_CLAIM",
      level: 0, // 这里是数字输入框的默认值
    },
    scoreObjList: [
      { score: 85, typeEnum: "INSURANCE" },
      { score: 85, typeEnum: "CLAIM" },
    ],
    acquisitionTypeList: ["TAKE_PHOTO"],
    sourceTypeList: ["SYSTEM_INTERGRATION_CREATE"],
    // selectedConfigs: ["FACE", "PIG_FACE", "NOSE"], // 存储选中的配置类型
    selectedConfigs: [],
    selectedfields:[],
    acquisitionOptions: [
      {
        picTypeEnum: "FACE",
        label: "正脸",
        color: "blue",
        shotNum: 3,
        defaultScore: 80,
        minScore: 70,
        degression: 5,
      },
      {
        picTypeEnum: "PIG_FACE",
        label: "侧脸",
        color: "blue",
        shotNum: 3,
        defaultScore: 80,
        minScore: 70,
        degression: 5,
      },
      {
        picTypeEnum: "NOSE",
        label: "鼻纹",
        color: "blue",
        shotNum: 3,
        defaultScore: 80,
        minScore: 70,
        degression: 5,
      },
    ],
    collectFields:[{
      field: "LIVESTOCK_AGE",
      isRequired:  '1',
    }],
    idCardVerification: 1,
    phoneNumberVerification: 1,
  },
  idCardVerification: 1,
  phoneNumberVerification: 1,
  showRepeatTarget: 1,
  allowRepeatBatchAudit: 0,
  enableFuzzyCheck: 1,
  verifyTargetOrCollar: [],
  earTagGenerator: null,
});
let ruleForm = reactive<ruleFormConfigItem>({
  id: "",
  farmerName: "",
  deptName: "",
  certificateType: "",
  phone: "",
  idCard: "",
  addr: "",
  url: "",
});

const PicTypeDisplayMap: Record<string, string> = {
  [PicTypeEnum.FACE]: "正脸",
  [PicTypeEnum.NOSE]: "鼻纹",
  [PicTypeEnum.LEFT_FACE]: "左侧脸",
  [PicTypeEnum.RIGHT_FACE]: "右侧脸",
  [PicTypeEnum.PIG_FACE]: "侧脸",
  [PicTypeEnum.PIG_BODY]: "侧身",
};
const CollectFieldMap: Record<string, string> = {
  "LIVESTOCK_AGE": "畜龄（月）"
};
const rules = reactive<FormRules>({
  compCode: [
    { required: true, message: "请输入租户代码", trigger: "blur" },
    { pattern: /^[a-zA-Z0-9]+$/, message: "只允许大小写字母和数字" },
  ],
  compName: [{ required: true, message: "请输入租户名称", trigger: "blur" }],
  deptCode: [
    { required: true, message: "请输入一级机构代码", trigger: "blur" },
  ],
  phone: [{ validator: validatePhone, trigger: "blur", required: false }],
});
const dialogVisible = ref(false);
const dialogTitle = ref<string>("养殖户信息");
const tableData = ref<any>([]);
const total = ref(0);
const dialogVisibleType = ref<string>("");
const dialogVisibleTypeValue = ref<string>("");
const { proxy }: any = getCurrentInstance();
const tenantConfigVisible = ref(false); // 租户配置dialog
const activeName = ref<string>("1"); // 租户配置tab active

const currentCompCode = ref<string>("");

// 最终相似度计算
const liveComparison = reactive<IModelConfig>({
  configType: "INSURE",
  id: "",
  isEnabled: 0, // 是否启用大模型
  invokeModel: "openAI", // 调用的模型
  companySimilarityPre: 0, //最小相似度
  companySimilarityPost: 0, // 最大相似度
  modelPromptWord: "", // 提示词
  largeModelConditions: [
    {
      largeModelSimilarity: 0,
      largeModelSimilarityProp: 0,
      companySimilarityProp: 0,
    },
    {
      largeModelSimilarity: 0,
      largeModelSimilarityProp: 0,
      companySimilarityProp: 0,
    },
  ],
});
// 活死对比
const lifeDeathComparison = reactive<IModelConfig>({
  configType: "ACCEPT",
  id: "",
  isEnabled: 0, // 是否启用大模型
  invokeModel: "openAI", // 调用的模型
  companySimilarityPre: 0, //最小相似度
  companySimilarityPost: 0, // 最大相似度
  modelPromptWord: "", // 提示词
  largeModelConditions: [
    {
      largeModelSimilarity: 0,
      largeModelSimilarityProp: 0,
      companySimilarityProp: 0,
    },
    {
      largeModelSimilarity: 0,
      largeModelSimilarityProp: 0,
      companySimilarityProp: 0,
    },
  ],
});
const DEFAULT_COLLECT_FIELDS = [
  { field: "LIVESTOCK_AGE", isRequired: '0' }
  // 可以添加更多默认字段
]
// 2. 创建响应式引用，初始化为默认值
const insureCollectFields = ref([...DEFAULT_COLLECT_FIELDS]);
const paymentCollectFields = ref([...DEFAULT_COLLECT_FIELDS]);
const NO_0 = "NO_0";
const YES_1 = "YES_1";
//推送数据
// 承保验标推送配置
// 定义推送配置接口
const insurancePushConfig = reactive<PushConfigState>({
  enable: NO_0,
  apiValue: '',
  apiName: '',
  apiUrl: '',
  targetRange: 'ALL',
  modeList: ['1'],
  modeOptions: [
    { label: '所有采集的部位全部、含正脸、左侧脸、右侧脸、鼻纹', value: 1 },
    { label: '所有采集的部位最优一张、含正脸、左侧脸、右侧脸、鼻纹', value: 2 },
    { label: '按标的合并所有采集部位为一张图片', value: 3 },
    { label: '其他照片、视频', value: 4 }
  ],
  targetRangeOptions: [
    { label: '唯一标的', value: 'NORMAL' },
    { label: '重复标的', value: 'REPEAT' },
    { label: '全部标的', value: 'ALL' }
  ]
});

// 理赔案件推送配置
const claimPushConfig = reactive<PushConfigState>({
  enable: NO_0,
  apiValue: '',
  apiName: '',
  apiUrl: '',
  targetRange: 'ALL',
  modeList: ['1'],
  modeOptions: [
    { label: '所有采集的部位全部、含正脸、左侧脸、右侧脸、鼻纹', value: 1 },
    { label: '所有采集的部位最优一张、含正脸、左侧脸、右侧脸、鼻纹', value: 2 },
    { label: '按标的合并所有采集部位为一张图片', value: 3 },
    { label: '其他照片、视频', value: 4 }
  ],
  targetRangeOptions: [
    { label: '唯一标的', value: 'NORMAL' },
    { label: '重复标的', value: 'REPEAT' },
    { label: '全部标的', value: 'ALL' }
  ]
});

// 可选的推送接口列表
const insuranceApiOptions = ref<Array<{ apiValue: string; apiName: string; apiUrl: string }>>([]);
const claimApiOptions = ref<Array<{ apiValue: string; apiName: string; apiUrl: string }>>([]);

// 加载状态
const isLoading = ref(false);
//水印配置
// 承保验标配置
const insuranceWaterConfig = reactive({
  id: undefined as number | undefined,
  compCode: "",
  configType: "INSURANCE",
  configOptionList: [] as string[],
  enable: NO_0,
  logoFileId: "" as string,
});

// 理赔验标配置
const claimWaterConfig = reactive({
  id: undefined as number | undefined,
  compCode: "",
  configType: "CLAIM",
  configOptionList: [] as string[],
  enable: NO_0,
  logoFileId: "" as string,
});

const COS = require("cos-js-sdk-v5");
const dialogImageUrl = ref("");
const dialogVisibleImage = ref(false);
let tenCosData = {};
const fileList = ref<Array<UploadProps>>([]);

onMounted(() => {
  getTencentFn();
  nextTick(() => {
    calculateTableRows();
  });
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  // onSearch(true);
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener("resize", debouncedCalculate);
});
watch(
  tableData,
  () => {
    if (tableData.value.length > 0) {
      // 只在有数据时才重新计算
      nextTick(() => {
        calculateTableRows();
      });
    }
  },
  { immediate: false }
);
onUnmounted(() => {
  window.removeEventListener("resize", calculateTableRows);
  userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
  let timer: any = null;
  return function (this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      userManuallySetPageSize.value = false; // 重置标志位
      fn.apply(this, args);
    }, delay);
  };
};
const getPicTypeDisplayText = (picTypeEnum: string) => {
  return PicTypeDisplayMap[picTypeEnum] || "未知类型";
};

const getCollectFieldText = (field: string) => {
  return CollectFieldMap[field] || "未知类型";
};
const handleClose = (formEl: any, type: boolean) => {
  formEl.resetFields();
  ruleForm.id = "";
  if (type) {
    dialogVisible.value = false;
  }
};
const photoDownload = () => {
  // if (!selectTableRows.value.length) {
  //   ElMessage({
  //     message: "请先选择农户",
  //     type: "warning",
  //   });
  //   return;
  // }
  // const farmerIds = selectTableRows.value.map((item: { id: any }) => {
  //   return item.id;
  // });
  // downLoadZip({ farmerIds: farmerIds, fileName: "农户标的.zip" }).then(
  //   () => {
  //     ElMessage({
  //       message: "下载成功",
  //       type: "success",
  //     });
  //   }
  // );
};
const onSearch = (type: boolean) => {
  if (type) {
    queryForm.pageIndex = 1;
  }
  getTenanpageList(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
};

const updateEnableFlagFn = (value: string, compCode: string) => {
  let param = {
    compCode,
  };
  changeEnable(compCode)
    .then((res: any) => {
      ElMessage({
        type: "success",
        message: "切换成功",
      });
      onSearch(true);
    })
    .catch((err: any) => {
      onSearch(true);
    });
};
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      let requestUrl =
        dialogVisibleTypeValue.value !== "add"
          ? updateCompanyInfo
          : addCompanyInfo;
      requestUrl(ruleForm)
        .then((res) => {
          ElMessage({
            type: "success",
            message: "更新成功",
          });
          // onSearch(true);
          dialogVisibleType.value = "";
          dialogVisible.value = false;
          formEl && formEl.resetFields();
        })
        .catch((err: any) => {
          onSearch(true);
        });
    } else {
      console.log("123123", fields);
    }
  });
};
const submitAllForm = async () => {
  const formEl = ruleFormRefAll.value;
  if (!formEl) return;
  // 定义一个函数来检查分数是否有效，并显示错误消息
  const checkScores = (
    options: { defaultScore: number; minScore: number }[]
  ) => {
    return options.some((item) => {
      if (item.defaultScore < item.minScore) {
        ElMessage({
          message: "默认阈值应大于等于最小阈值",
          type: "error",
        });
        return true; // 发现无效分数时返回 true
      }
      return false;
    });
  };

  // 检查两组分数的有效性
  const hasInvalidScoreInsure = checkScores(
    allForm.insureForm.acquisitionOptions
  );
  const hasInvalidScorePayment = checkScores(
    allForm.paymentForm.acquisitionOptions
  );

  // 如果有无效分数，则不进行后续处理
  if (hasInvalidScoreInsure || hasInvalidScorePayment) return;

  await formEl.validate(async (valid: boolean, fields: any) => {
    if (valid) {      
      allForm.insureForm.acquisitionOptions =
        allForm.insureForm.acquisitionOptions.filter((option) => {
          return allForm.insureForm.selectedConfigs.includes(
            option.picTypeEnum
          );
        });
      //采集字段      
      const fields = insureCollectFields?.value?.filter((option) => {
        const selected = allForm.insureForm.selectedfields || [];
        
        return selected.includes(option.field);
      });
      
      allForm.insureForm.collectFields = fields || [];

      const insureForm = {
        id: allForm.insureForm.id,
        compCode: allForm.insureForm.compCode,
        typeEnum: "INSURANCE",
        companyOptionObj: {
          ...allForm.insureForm,
          idCardVerification: allForm.idCardVerification,
          phoneNumberVerification: allForm.phoneNumberVerification,
          showRepeatTarget: allForm.showRepeatTarget,
          allowRepeatBatchAudit: allForm.allowRepeatBatchAudit,
          enableFuzzyCheck: allForm.enableFuzzyCheck,
          verifyTargetOrCollar: allForm.verifyTargetOrCollar || [],
          earTagGenerator: allForm.earTagGenerator,
        },
      };
      allForm.paymentForm.acquisitionOptions =
        allForm.paymentForm.acquisitionOptions.filter((option) => {
          return allForm.paymentForm.selectedConfigs.includes(
            option.picTypeEnum
          );
        });
      //采集字段
      const payFields = paymentCollectFields?.value?.filter((option) => {
        const selected = allForm.paymentForm.selectedfields || [];
        return selected.includes(option.field);
      });
      allForm.paymentForm.collectFields = payFields || [];
      
      const paymentForm = {
        id: allForm.paymentForm.id,
        compCode: allForm.paymentForm.compCode,
        typeEnum: "CLAIM",
        companyOptionObj: {
          ...allForm.paymentForm,
          idCardVerification: allForm.idCardVerification,
          phoneNumberVerification: allForm.phoneNumberVerification,
          showRepeatTarget: allForm.showRepeatTarget,
          allowRepeatBatchAudit: allForm.allowRepeatBatchAudit,
          enableFuzzyCheck: allForm.enableFuzzyCheck,
          verifyTargetOrCollar: allForm.verifyTargetOrCollar || [],
          earTagGenerator: allForm.earTagGenerator,
        },
      };
      const dataToSend = {
        compCode: allForm.insureForm.compCode || allForm.paymentForm.compCode,
        companyOptionDTOList: [{ ...insureForm }, { ...paymentForm }],
      };

      updateTenantConfig(dataToSend);
    } else {
      console.log("Validation failed:", fields);
    }
  });
};

const resetForm = (formEl: any, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  dialogVisibleType.value = "";
  type && (dialogVisible.value = false);
};
const resetAllForm = () => {
  const formEl = ruleFormRefAll.value;
  if (!formEl) return;
  formEl.resetFields();
  // dialogConfigVisible.value = false;
};
function convertDataToAllForm(
  companyOptionDTOList: Array<{
    typeEnum: string;
    companyOptionObj: any;
    compCode: string;
    id: string;
  }>
): allFormItem {
  let id: string | undefined;
  let compCode: string | undefined;
  let insureForm: InsureForm | undefined;
  let paymentForm: PaymentForm | undefined;
  let idCardVerification: number | undefined;
  let phoneNumberVerification: number | undefined;
  let showRepeatTarget: number | undefined;
  let allowRepeatBatchAudit: number | undefined;
  let enableFuzzyCheck: number | undefined;
  let verifyTargetOrCollar: string[] | undefined;
  let earTagGenerator: string | undefined;

  const form = initializeAllForm();
  companyOptionDTOList.forEach((item) => {
    if (item.typeEnum === "INSURANCE") {
      let selectedConfigs = item.companyOptionObj.acquisitionOptions.map(
        (ite) => ite.picTypeEnum
      );
      //采集字段
      let selectedfields = item.companyOptionObj.collectFields?.map(
        (ite) => ite.field
      );
      let companyOptionObj = item.companyOptionObj;
      console.log("companyOptionObj", companyOptionObj);

      const initAcquisitionOptions = [...form.insureForm.acquisitionOptions];
      companyOptionObj.acquisitionOptions.forEach((newSetting) => {
        const index = initAcquisitionOptions.findIndex(
          (option) => option.picTypeEnum === newSetting.picTypeEnum
        );
        if (index !== -1) {
          // 如果找到匹配的 picTypeEnum，则更新对应项
          initAcquisitionOptions[index] = {
            ...initAcquisitionOptions[index],
            shotNum: newSetting.shotNum,
            defaultScore: newSetting.defaultScore,
            minScore: newSetting.minScore,
            degression: newSetting.degression,
          };
        }
      });
      companyOptionObj.acquisitionOptions = cloneDeep(initAcquisitionOptions);
      //采集字段
      let initCollectFields = [...insureCollectFields.value];
      if(!companyOptionObj?.collectFields || companyOptionObj?.collectFields.length === 0) {
        initCollectFields = [...DEFAULT_COLLECT_FIELDS];
      }else {
        companyOptionObj.collectFields?.forEach((newSetting) => {
        const index = initCollectFields.findIndex(
          (option) => option.field === newSetting.field
        );
        if (index !== -1) {
          // 如果找到匹配的 collectFildEnum，则更新对应项
          initCollectFields[index] = {
            ...initCollectFields[index],
            isRequired: newSetting.isRequired,
          };
        } else {
          initCollectFields[index] = {
            ...initCollectFields[index],
            isRequired: '0',
          };
        }
      });
      }
      console.log("initCollectFields", initCollectFields);
      insureCollectFields.value = cloneDeep(initCollectFields);

      // We can assume that idCardVerification and phoneNumberVerification are the same for both forms
      if (companyOptionObj.idCardVerification !== undefined) {
        idCardVerification = companyOptionObj.idCardVerification;
      }
      if (companyOptionObj.phoneNumberVerification !== undefined) {
        phoneNumberVerification = companyOptionObj.phoneNumberVerification;
      }
      if (companyOptionObj.showRepeatTarget !== undefined) {
        showRepeatTarget = companyOptionObj.showRepeatTarget;
      }
      if (companyOptionObj.verifyTargetOrCollar !== undefined) {
        verifyTargetOrCollar = companyOptionObj.verifyTargetOrCollar || [];
      }
      if (companyOptionObj.earTagGenerator !== undefined) {
        earTagGenerator = companyOptionObj.earTagGenerator;
      }
      if (companyOptionObj.allowRepeatBatchAudit !== undefined) {
        allowRepeatBatchAudit = companyOptionObj.allowRepeatBatchAudit;
      }
      if (companyOptionObj.enableFuzzyCheck !== undefined) {
        enableFuzzyCheck = companyOptionObj.enableFuzzyCheck;
      }
      if (item.compCode !== undefined) {
        compCode = item.compCode;
      }
      if (item.id !== undefined) {
        id = item.id;
      }

      insureForm = {
        ...companyOptionObj,
        selectedConfigs: selectedConfigs,
        selectedfields: selectedfields,
        compCode: compCode,
        id: id,
      };
    } else if (item.typeEnum === "CLAIM") {
      let selectedConfigs = item.companyOptionObj.acquisitionOptions.map(
        (ite) => ite.picTypeEnum
      );
      let selectedfields = item.companyOptionObj.collectFields?.map(
        (ite) => ite.field
      );
      let companyOptionObj = item.companyOptionObj;
      const initAcquisitionOptions = [...form.paymentForm.acquisitionOptions];
      companyOptionObj.acquisitionOptions.forEach((newSetting) => {
        const index = initAcquisitionOptions.findIndex(
          (option) => option.picTypeEnum === newSetting.picTypeEnum
        );
        if (index !== -1) {
          // 如果找到匹配的 picTypeEnum，则更新对应项
          initAcquisitionOptions[index] = {
            ...initAcquisitionOptions[index],
            shotNum: newSetting.shotNum,
            defaultScore: newSetting.defaultScore,
            minScore: newSetting.minScore,
            degression: newSetting.degression,
          };
        }
      });
      companyOptionObj.acquisitionOptions = cloneDeep(initAcquisitionOptions);
      //采集字段
      let initCollectFields = [...paymentCollectFields.value];
      if(!companyOptionObj?.collectFields || companyOptionObj?.collectFields.length === 0) {
        initCollectFields = [...DEFAULT_COLLECT_FIELDS];
      }else {
        companyOptionObj.collectFields?.forEach((newSetting) => {
        const index = initCollectFields.findIndex(
          (option) => option.field === newSetting.field
        );
        if (index !== -1) {
          // 如果找到匹配的 collectFildEnum，则更新对应项
          initCollectFields[index] = {
            ...initCollectFields[index],
            isRequired: newSetting.isRequired,
          };
        } else {
          initCollectFields[index] = {
            ...initCollectFields[index],
            isRequired: '0',
          };
        }
      });
      }
      console.log("initCollectFields", initCollectFields);
      paymentCollectFields.value = cloneDeep(initCollectFields);


      // If for some reason idCardVerification or phoneNumberVerification are missing from insureForm, we can pick them up from paymentForm
      if (
        idCardVerification === undefined &&
        item.companyOptionObj.idCardVerification !== undefined
      ) {
        idCardVerification = item.companyOptionObj.idCardVerification;
      }
      if (
        phoneNumberVerification === undefined &&
        item.companyOptionObj.phoneNumberVerification !== undefined
      ) {
        phoneNumberVerification = item.companyOptionObj.phoneNumberVerification;
      }
      if (
        showRepeatTarget === undefined &&
        item.companyOptionObj.showRepeatTarget !== undefined
      ) {
        showRepeatTarget = item.companyOptionObj.showRepeatTarget;
      }
      if (
        verifyTargetOrCollar === undefined &&
        item.companyOptionObj.verifyTargetOrCollar !== undefined
      ) {
        verifyTargetOrCollar = item.companyOptionObj.verifyTargetOrCollar || [];
      }
      if (
        earTagGenerator === undefined &&
        item.companyOptionObj.earTagGenerator !== undefined
      ) {
        earTagGenerator = item.companyOptionObj.earTagGenerator;
      }
      if (
        allowRepeatBatchAudit === undefined &&
        item.companyOptionObj.allowRepeatBatchAudit !== undefined
      ) {
        allowRepeatBatchAudit = item.companyOptionObj.allowRepeatBatchAudit;
      }
      if (
        enableFuzzyCheck === undefined &&
        item.enableFuzzyCheck !== undefined
      ) {
        enableFuzzyCheck = item.companyOptionObj.enableFuzzyCheck;
      }
      if (item.compCode !== undefined) {
        compCode = item.compCode;
      }
      if (item.id !== undefined) {
        id = item.id;
      }
      paymentForm = {
        ...item.companyOptionObj,
        selectedConfigs: selectedConfigs,
        selectedfields: selectedfields,
        compCode: compCode,
        id: id,
      };
    }
  });

  // Ensure that we have all the required fields before returning the allFormItem
  if (
    !insureForm ||
    !paymentForm ||
    idCardVerification === undefined ||
    phoneNumberVerification === undefined ||
    showRepeatTarget === undefined ||
    allowRepeatBatchAudit === undefined ||
    enableFuzzyCheck === undefined ||
    verifyTargetOrCollar === undefined ||
    earTagGenerator === undefined
  ) {
    throw new Error("Missing required fields to construct allFormItem");
  }
  allForm.idCardVerification = idCardVerification;
  allForm.insureForm = insureForm;
  allForm.paymentForm = paymentForm;
  allForm.phoneNumberVerification = phoneNumberVerification;
  allForm.showRepeatTarget = showRepeatTarget;
  allForm.allowRepeatBatchAudit = allowRepeatBatchAudit;
  allForm.enableFuzzyCheck = enableFuzzyCheck;
  allForm.verifyTargetOrCollar = verifyTargetOrCollar;
  allForm.earTagGenerator = earTagGenerator;
}

const addEvent = () => {
  // 直接修改对象的属性，而不是重新赋值整个对象
  Object.keys(ruleForm).forEach((key) => {
    ruleForm[key] = ""; // 这里可以根据字段类型设置不同的默认值
  });
  // 对于 'url' 字段，如果需要设置为 null，可以特别处理
  ruleForm.url = null;
  dialogTitle.value = "租户信息";
  dialogVisible.value = true;
  dialogVisibleType.value = "add";
  dialogVisibleTypeValue.value = "add";
};
const viewDetails = (row: any, type: string) => {
  dialogTitle.value = "租户信息";
  dialogVisible.value = true;
  dialogVisibleType.value = type;
  dialogVisibleTypeValue.value = type;
  setTimeout(() => {
    for (let key in row) {
      const k = key as keyof ruleFormConfigItem;
      setField(ruleForm, k, row[k]);
    }
  }, 200);
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};

// 租户配置tab切换
const handleClick = (tab: TabsPaneContext, event: Event) => {
  console.log(tab, event);
};

const viewConfig = async (row: { compCode: string }) => {
  tenantConfigVisible.value = true;
  currentCompCode.value = row.compCode;

  // 重置推送配置
  resetPushConfigs();

  try {
    const res = await getCompanyOption(row.compCode);
    const {
      verificationCollection,
      liveComparison,
      lifeDeathComparison,
      pushDataOptions,
      watermarkOption,
    } = res;
    // 处理验标采集配置
    convertDataToAllForm(verificationCollection);
    // 生成活活、活死对比信息 （无值采用关闭弹窗的初始化数据）
    if (liveComparison) {
      generateComparisonInfo("live", liveComparison);
    }

    if (lifeDeathComparison) {
      generateComparisonInfo("lifeDeath", lifeDeathComparison);
    }
    // 处理推送配置
    if (pushDataOptions) {
      await initPushDataConfig(pushDataOptions);
    } else {
      await initPushDataConfig([]);
    }

    if (watermarkOption) {
      initWatermarkConfig(watermarkOption);
    }
  } catch (error) {
    console.error('获取租户配置失败:', error);
    await initPushDataConfig([]);
  }
};
// 推送配置
// 初始化数据 - 从后端返回的pushDataOptions中提取
// 初始化推送配置
const initPushDataConfig = async (pushDataOptions: any[]) => {
  isLoading.value = true;

  try {
    // 清空现有选项
    insuranceApiOptions.value = [];
    claimApiOptions.value = [];

    if (!pushDataOptions || !Array.isArray(pushDataOptions)) {
      resetPushConfigs();
      return;
    }

    // 分离承保和理赔选项
    const validOptions = pushDataOptions.filter(item => item && item.apiType);

    insuranceApiOptions.value = validOptions
        .filter(item => item.apiType === 'INSURANCE')
        .map(item => ({
          apiValue: item.apiValue || '',
          apiName: item.apiName || '',
          apiUrl: item.apiUrl || ''
        }));

    claimApiOptions.value = validOptions
        .filter(item => item.apiType === 'CLAIM')
        .map(item => ({
          apiValue: item.apiValue || '',
          apiName: item.apiName || '',
          apiUrl: item.apiUrl || ''
        }));

    // 提取现有配置
    await extractExistingConfig(pushDataOptions);
  } catch (error) {
    console.error('初始化推送配置失败:', error);
    resetPushConfigs();
  } finally {
    isLoading.value = false;
  }
};

// 提取现有配置
const extractExistingConfig = async (pushDataOptions: any[]) => {
  await nextTick();

  // 提取承保配置
  const insuranceOption = pushDataOptions.find(item => item.apiType === 'INSURANCE');
  if (insuranceOption) {
    insurancePushConfig.id = insuranceOption.id;
    insurancePushConfig.compCode = insuranceOption.compCode || '';
    insurancePushConfig.apiValue = insuranceOption.apiValue || '';
    insurancePushConfig.apiName = insuranceOption.apiName || '';
    insurancePushConfig.apiUrl = insuranceOption.apiUrl || '';
    insurancePushConfig.enable = insuranceOption.enable || NO_0;
    insurancePushConfig.targetRange = insuranceOption.targetRange || 'ALL';
    insurancePushConfig.modeList = parseModeList(insuranceOption.modeList, insuranceOption.modes);
  } else {
    resetInsuranceConfig();
  }

  // 提取理赔配置
  const claimOption = pushDataOptions.find(item => item.apiType === 'CLAIM');
  if (claimOption) {
    claimPushConfig.id = claimOption.id;
    claimPushConfig.compCode = claimOption.compCode || '';
    claimPushConfig.apiValue = claimOption.apiValue || '';
    claimPushConfig.apiName = claimOption.apiName || '';
    claimPushConfig.apiUrl = claimOption.apiUrl || '';
    claimPushConfig.enable = claimOption.enable || NO_0;
    claimPushConfig.targetRange = claimOption.targetRange || 'ALL';
    claimPushConfig.modeList = parseModeList(claimOption.modeList, claimOption.modes);
  } else {
    resetClaimConfig();
  }
};

// 解析模式列表
const parseModeList = (modeList: any, modes: string): string[] => {
  if (Array.isArray(modeList)) {
    return modeList.filter(mode => ['1', '2', '3', '4'].includes((mode)));
  }

  if (modes) {
    return modes
        .split(',')
        .map(mode => mode.trim())
        .filter(mode => ['1', '2', '3', '4'].includes(mode));
  }

  return ['1']; // 默认值
};

// 重置所有推送配置
const resetPushConfigs = () => {
  resetInsuranceConfig();
  resetClaimConfig();
};

// 重置承保配置
const resetInsuranceConfig = () => {
  insurancePushConfig.id = undefined;
  insurancePushConfig.compCode = '';
  insurancePushConfig.apiValue = '';
  insurancePushConfig.apiName = '';
  insurancePushConfig.apiUrl = '';
  insurancePushConfig.enable = NO_0;
  insurancePushConfig.targetRange = 'ALL';
  insurancePushConfig.modeList = ['1'];
};

// 重置理赔配置
const resetClaimConfig = () => {
  claimPushConfig.id = undefined;
  claimPushConfig.compCode = '';
  claimPushConfig.apiValue = '';
  claimPushConfig.apiName = '';
  claimPushConfig.apiUrl = '';
  claimPushConfig.enable = NO_0;
  claimPushConfig.targetRange = 'ALL';
  claimPushConfig.modeList = ['1'];
};

// 处理配置开关切换
const handleConfigToggle = async (type: 'insurance' | 'claim') => {
  await nextTick();

  const config = type === 'insurance' ? insurancePushConfig : claimPushConfig;
  const options = type === 'insurance' ? insuranceApiOptions : claimApiOptions;

  if (config.enable === NO_0) {
    // 禁用时重置配置
    config.apiValue = '';
    config.apiName = '';
    config.apiUrl = '';
    config.targetRange = 'ALL';
    config.modeList = ['1'];
  } else if (options.value.length > 0 && !config.apiValue) {
    // 启用时自动选择第一个选项
    setTimeout(() => {
      const firstOption = options.value[0];
      if (firstOption) {
        config.apiValue = firstOption.apiValue;
        config.apiName = firstOption.apiName;
        config.apiUrl = firstOption.apiUrl;
      }
    }, 100);
  }
};

// 处理接口选择
const handleApiSelect = (type: 'insurance' | 'claim', value: string) => {
  const config = type === 'insurance' ? insurancePushConfig : claimPushConfig;
  const options = type === 'insurance' ? insuranceApiOptions : claimApiOptions;

  if (!value) {
    config.apiName = '';
    config.apiUrl = '';
    return;
  }

  const selectedOption = options.value.find(option => option.apiValue === value);
  if (selectedOption) {
    config.apiName = selectedOption.apiName;
    config.apiUrl = selectedOption.apiUrl;
  }
};

// 生成提交数据
const generatePushDataOptions = () => {
  const options: PushDataConfig[] = [];

  // 承保配置
  if (insurancePushConfig.enable === YES_1 && insurancePushConfig.apiValue) {
    options.push({
      id: insurancePushConfig.id,
      compCode: currentCompCode.value,
      apiValue: insurancePushConfig.apiValue,
      apiName: insurancePushConfig.apiName,
      apiUrl: insurancePushConfig.apiUrl,
      apiType: 'INSURANCE',
      enable: insurancePushConfig.enable,
      targetRange: insurancePushConfig.targetRange,
      modeList: insurancePushConfig.modeList,
      modes: insurancePushConfig.modeList.join(',')
    });
  }

  // 理赔配置
  if (claimPushConfig.enable === YES_1 && claimPushConfig.apiValue) {
    options.push({
      id: claimPushConfig.id,
      compCode: currentCompCode.value,
      apiValue: claimPushConfig.apiValue,
      apiName: claimPushConfig.apiName,
      apiUrl: claimPushConfig.apiUrl,
      apiType: 'CLAIM',
      enable: claimPushConfig.enable,
      targetRange: claimPushConfig.targetRange,
      modeList: claimPushConfig.modeList,
      modes: claimPushConfig.modeList.join(',')
    });
  }

  return options;
};
// 校验推送配置
const validatePushConfig = (): boolean => {
  if (insurancePushConfig.enable === YES_1 && !insurancePushConfig.apiValue) {
    ElMessage.error('请选择承保验标的推送接口');
    return false;
  }

  if (claimPushConfig.enable === YES_1 && !claimPushConfig.apiValue) {
    ElMessage.error('请选择理赔案件的推送接口');
    return false;
  }

  if (insurancePushConfig.enable === YES_1 && insurancePushConfig.modeList.length === 0) {
    ElMessage.error('请至少选择一种承保验标的照片方式');
    return false;
  }

  if (claimPushConfig.enable === YES_1 && claimPushConfig.modeList.length === 0) {
    ElMessage.error('请至少选择一种理赔案件的照片方式');
    return false;
  }

  return true;
};
//图片水印
// 初始化数据 - 从后端返回的watermarkOptions中提取
const initWatermarkConfig = (watermarkOptions: any[]) => {
  if (!watermarkOptions || watermarkOptions.length === 0) return;
  fileList.value = [];
  // 提取承保配置
  const insuranceOption = watermarkOptions.find(
    (item) => item.configType === "INSURANCE"
  );
  if (insuranceOption) {
    insuranceWaterConfig.id = insuranceOption.id;
    insuranceWaterConfig.compCode = insuranceOption.compCode;
    insuranceWaterConfig.configOptionList = insuranceOption.configOptionList || [];
    insuranceWaterConfig.enable = insuranceOption.enable || NO_0;
    insuranceWaterConfig.logoFileId = insuranceOption.logoFileId || "";
  }
  console.log("insuranceWaterConfig", insuranceWaterConfig);
  // 提取理赔配置
  const claimOption = watermarkOptions.find(
    (item) => item.configType === "CLAIM"
  );
  if (claimOption) {
    claimWaterConfig.id = claimOption.id;
    claimWaterConfig.compCode = claimOption.compCode;
    claimWaterConfig.configOptionList = claimOption.configOptionList || [];
    claimWaterConfig.enable = claimOption.enable || NO_0;
    claimWaterConfig.logoFileId = claimOption.logoFileId || "";
  }
  console.log("claimWaterConfig1", claimWaterConfig);
  let logoFileId = claimOption?.logoFileId || insuranceOption?.logoFileId;
  if (logoFileId) {
    fileList.value.push({
      name: "LOGO",
      url: `https://standard-target-1321467951.cos.ap-guangzhou.myqcloud.com/${logoFileId}`,
    });
  } else {
    fileList.value = [];
  }
  console.log('fileList.value', fileList.value)
};

// 生成提交给后端的watermarkOptions
const generateWatermarkOptions = () => {
  const options = [];

  // 承保配置
  if (
    insuranceWaterConfig.enable === YES_1 ||
    insuranceWaterConfig.configOptionList.length > 0
  ) {
    options.push({
      id: insuranceWaterConfig.id,
      compCode: currentCompCode.value,
      configType: "INSURANCE",
      configOptionList: insuranceWaterConfig.configOptionList,
      configOption: insuranceWaterConfig.configOptionList.join(","),
      enable: insuranceWaterConfig.enable,
      logoFileId: insuranceWaterConfig.logoFileId || "",
    });
  }

  // 理赔配置
  if (
    claimWaterConfig.enable === YES_1 ||
    claimWaterConfig.configOptionList.length > 0
  ) {
    options.push({
      id: claimWaterConfig.id,
      compCode: currentCompCode.value,
      configType: "CLAIM",
      configOptionList: claimWaterConfig.configOptionList,
      configOption: claimWaterConfig.configOptionList.join(","),
      enable: claimWaterConfig.enable,
      logoFileId: claimWaterConfig.logoFileId || "",
    });
  }

  return options;
};

// 启用状态变化处理
const handleInsuranceWaterEnableChange = (enabled: string) => {
  if (enabled === NO_0) {
    // 禁用时清空选项
    insuranceWaterConfig.configOptionList = [];
  }
};

const handleClaimWaterEnableChange = (enabled: string) => {
  if (enabled === NO_0) {
    // 禁用时清空选项
    claimWaterConfig.configOptionList = [];
  }
};
/**
 * 重置水印配置
 */
 const resetWaterConfig = () => {
  // 重置承保配置
  insuranceWaterConfig.id = undefined;
  insuranceWaterConfig.compCode = "";
  insuranceWaterConfig.configType = "INSURANCE";
  insuranceWaterConfig.configOptionList = [];
  insuranceWaterConfig.enable = NO_0;
  insuranceWaterConfig.logoFileId = "";
  
  // 重置理赔配置
  claimWaterConfig.id = undefined;
  claimWaterConfig.compCode = "";
  claimWaterConfig.configType = "CLAIM";
  claimWaterConfig.configOptionList = [];
  claimWaterConfig.enable = NO_0;
  claimWaterConfig.logoFileId = "";
};
// 生成对比配置
const generateComparisonInfo = (
  comparison: "live" | "lifeDeath",
  data: IModelConfig
) => {
  const largeModelConditions: modelCalc[] = [
    {
      largeModelSimilarity: 0,
      largeModelSimilarityProp: 0,
      companySimilarityProp: 0,
    },
    {
      largeModelSimilarity: 0,
      largeModelSimilarityProp: 0,
      companySimilarityProp: 0,
    },
  ];
  const targetComparison =
    comparison === "live" ? liveComparison : lifeDeathComparison;
  data.largeModelConditions =
    data.largeModelConditions && data.largeModelConditions.length > 0
      ? data.largeModelConditions
      : largeModelConditions;
  data.companySimilarityPost = data.companySimilarityPost || 0;
  data.companySimilarityPre = data.companySimilarityPre || 0;
  Object.assign(targetComparison, data);
};

// 初始化对比配置
const initComparisonData = (key: "liveComparison" | "lifeDeathComparison") => {
  return {
    configType: key === "liveComparison" ? "INSURE" : "ACCEPT",
    isEnabled: 0,
    invokeModel: "openAI",
    companySimilarityPre: 0,
    companySimilarityPost: 0,
    id: "",
    modelPromptWord: "",
    largeModelConditions: [
      {
        largeModelSimilarity: 0,
        largeModelSimilarityProp: 0,
        companySimilarityProp: 0,
      },
      {
        largeModelSimilarity: 0,
        largeModelSimilarityProp: 0,
        companySimilarityProp: 0,
      },
    ],
    compCode: "",
  };
};

// 初始化对比模型配置
const initializeComparison = (
  key: "liveComparison" | "lifeDeathComparison"
) => {
  const targetComparison: IModelConfig =
    key === "liveComparison" ? liveComparison : lifeDeathComparison;
  const initData = initComparisonData(key);
  Object.assign(targetComparison, initData);
};

// 租户配置弹窗关闭
const tenantConfigHandleClose = () => {
  tenantConfigVisible.value = false;
  currentCompCode.value = "";
  activeName.value = "1";
  resetAllForm();
  initializeComparison("liveComparison");
  initializeComparison("lifeDeathComparison");
  resetPushConfigs();
  resetWaterConfig();

};
// 租户配置弹窗确认
const tenantConfigHandleConfirm = () => {
  // 验标采集配置
  if (activeName.value === "1") {
    submitAllForm();
    return;
  }

  // 校验对比配置
  if (activeName.value === "2" || activeName.value === "3") {
    checkComparisonData();
    return;
  }
  // 推送配置
/*  if (activeName.value === "4") {
    checkPushData();
    return;
  }*/
  // 推送配置
  if (activeName.value === "4") {
    if (!validatePushConfig()) {
      return;
    }

    const pushData = {
      compCode: currentCompCode.value,
      pushDataOptions: generatePushDataOptions()
    };

    updateCompanyOption({ ...pushData, type: "4" })
        .then(() => {
          ElMessage.success('推送配置保存成功');
          tenantConfigHandleClose();
        })
        .catch(error => {
          console.error('保存推送配置失败:', error);
          ElMessage.error('保存推送配置失败');
        });
    return;
  }
  // 保存水印配置
  if (activeName.value === "5") {
    checkWatermarkConfig();
    return;
  }
};

// 校验活活对比和活死对比
const checkComparisonData = () => {
  const targetComparison: IModelConfig =
    activeName.value === "2" ? liveComparison : lifeDeathComparison;

  let isPass = true;

  targetComparison.compCode =
    targetComparison.compCode || currentCompCode.value;
  if (targetComparison.isEnabled === 1) {
    const keyMap: { [key: string]: string } = {
      // companySimilarityPre: "大模型调用区间不能为空或者0",
      // companySimilarityPost: "大模型调用区间不能为空或者0",
      modelPromptWord: "调用提示词不能为空",
    };

    for (const k of Object.keys(keyMap)) {
      if (!targetComparison[k]) {
        ElMessage.error(`${keyMap[k]}`);
        isPass = false;
        break;
      }
    }

    if (!isPass) return;

    const { largeModelConditions } = targetComparison;
    for (const condition of largeModelConditions) {
      if (!condition.largeModelSimilarity) {
        ElMessage.error("最终相似度计算-大模型相似度 不能为空或者0");
        isPass = false;
        break;
      }
      if (
        condition.largeModelSimilarityProp + condition.companySimilarityProp !=
        1
      ) {
        ElMessage.error(
          "最终相似度计算-公式 模型相似度和公司模型相似度相加需等于1"
        );
        isPass = false;
        break;
      }
    }
  }

  if (!isPass) return;

  let key = activeName.value === "2" ? "liveComparison" : "lifeDeathComparison";
  const data = {
    compCode: targetComparison.compCode,
    [key]: targetComparison,
  };
  updateTenantConfig(data);
};

// 校验推送配置
const checkPushData = () => {
  let data = {
    compCode: currentCompCode.value,
    pushDataOptions: generatePushDataOptions(),
  };
  updateTenantConfig(data);
};

// 校验水印配置
const checkWatermarkConfig = () => {
  let data = {
    compCode: currentCompCode.value,
    watermarkOptions: generateWatermarkOptions(),
  };
  updateTenantConfig(data);
};

// 更新配置
const updateTenantConfig = async (data: any) => {
  try {
    await updateCompanyOption({ ...data, type: activeName.value });
    ElMessage({ type: "success", message: "更新成功" });
    // onSearch(true);
    tenantConfigVisible.value = false;
    if (activeName.value === "1") {
      ruleFormRefAll.value && ruleFormRefAll.value.resetFields();
    }
    tenantConfigHandleClose();
  } catch (error) {
    console.error("An error occurred:", error);
    // onSearch(true);
  }
};

// 模型相似度区间 不能超过100
const modelSimilarOnBlur = (
  obj: IModelConfig,
  key: keyof Pick<
    IModelConfig,
    "companySimilarityPre" | "companySimilarityPost"
  >
) => {
  let value = parseFloat(parseFloat(obj[key].toString()).toFixed(2));
  if (value > 100) {
    ElMessage.error("公司模型相似度不能超过100");
    value = 0;
  }
  obj[key] = value || 0;
};

// 相似度计算条件：模型相似度 最大100
const modelSimilarConditionOnBlur = (event: any, obj: IModelConfig) => {
  let value = event.target.value;
  if (value > 100) {
    ElMessage.error("大模型相似度不能大于100");
    value = 0;
  }
  if (value < 0) {
    ElMessage.error("大模型相似度不能为0或负数");
    value = 0;
  }
  obj.largeModelConditions.forEach((n: modelCalc) => {
    n.largeModelSimilarity = value;
  });
};

// 相似度计算公式：模型相似度+公司相似度 = 1 保留1位小数
const modelSimilarCalcOnBlur = (
  event: any,
  obj: IModelConfig,
  index: number,
  key: string
) => {
  let value = parseFloat(parseFloat(event.target.value).toFixed(1));
  const { largeModelSimilarityProp, companySimilarityProp } =
    obj["largeModelConditions"][index];

  if (
    (key === "largeModelSimilarityProp" && value + companySimilarityProp > 1) ||
    (key === "companySimilarityProp" && value + largeModelSimilarityProp > 1)
  ) {
    ElMessage.error("模型相似度公式相加不能超过1");
    obj["largeModelConditions"][index][key] = 0;
    return;
  }
  obj["largeModelConditions"][index][key as keyof modelCalc] = value;
};

const uploadRequestFactory = (fieldId) => {
  return (options) => {
    const { file } = options; // 从options中提取文件对象
    UploadFilePublic(file, fieldId); // 调用实际的上传函数
  };
};

// 定义图片上传成功后的处理函数，接受一个字段名作为参数
function handleremove(picType, file, fileList) {
  // console.log("picType:", picType);
  // console.log("file:", file);
  // console.log("fileList:", fileList);
  insuranceWaterConfig.logoFileId = "";
  claimWaterConfig.logoFileId = "";
  fileList.value = [];
}

const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!;
  dialogVisibleImage.value = true;
};

const UploadFilePublic = (file, fieldId) => {
  // type用来判断 是图片还是视频
  // suffix是后缀名
  let uuid = uuidv4().replace(/-/g, ""); // 生成UUID并去掉所有'-'
  let fileName = uuid + file.name.substr(file.name.lastIndexOf(".")); // 保留原文件扩展名

  // 腾讯云COS配置
  const cos = new COS({
    getAuthorization: function (options, callback) {
      callback({
        TmpSecretId: tenCosData.tmpSecretId,
        TmpSecretKey: tenCosData.tmpSecretKey,
        SecurityToken: tenCosData.sessionToken,
        StartTime: tenCosData.startTime,
        ExpiredTime: tenCosData.expiredTime, // 时间戳，单位秒
      });
    },
  });
  fileList.value = [];
  try {
    // 上传文件到指定文件夹
    cos.uploadFile(
      {
        Bucket: tenCosData.bucket + "-" + tenCosData.appId,
        Region: tenCosData.region,
        Key: fileName,
        Body: file,
        onProgress: function (progressData) {
          console.log("上传进度:", JSON.stringify(progressData));
        },
      },
      (err, data) => {
        if (err) {
          console.error("上传失败:", err);
          return;
        }
        // console.log("上传成功:", data);
        console.log("fileName:", fileName);
        // console.log("fieldId:", fieldId);
        // 上传成功后，将文件URL赋值给对应的字段
        insuranceWaterConfig.logoFileId = fileName;
        claimWaterConfig.logoFileId = fileName;
        fileList.value.push({
          name: "LOGO",
          url: `https://standard-target-1321467951.cos.ap-guangzhou.myqcloud.com/${fileName}`,
        });
      }
    );
  } catch (e) {
    console.error("上传过程中发生错误:", e);
  }
};

const getTencentFn = () => {
  getTencentCloudConfig().then((res: any) => {
    localStorage.setItem("tenCos", JSON.stringify(res));
    tenCosData = res || JSON.parse(localStorage.getItem("tenCos") || "");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        inline: true,
        model: queryForm,
        class: "demo-form-inline",
        ref_key: "ruleFormRef",
        ref: ruleFormRef
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "租户编码",
            prop: "condition.compCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: queryForm.condition.compCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.condition.compCode) = $event)),
                placeholder: "租户编码",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "租户名称",
            prop: "condition.compName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: queryForm.condition.compName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.condition.compName) = $event)),
                placeholder: "租户名称",
                class: "unifiedInputBoxWidth"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onSearch(true))),
                icon: _unref(Search)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查 询")
                ]),
                _: 1
              }, 8, ["icon"]),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: addEvent
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新 增")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                plain: "",
                icon: _unref(RefreshRight),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (resetForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("重 置")
                ]),
                _: 1
              }, 8, ["icon"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: "",
        style: {"width":"100%"},
        height: "100%",
        onRowMounted: calculateTableRows
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号",
            width: "60",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "compCode",
            label: "租户编码",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "compName",
            label: "租户名称",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "enableFlag",
            label: "租户状态",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_switch, {
                modelValue: scope.row.enableFlag,
                "onUpdate:modelValue": ($event: any) => ((scope.row.enableFlag) = $event),
                "active-value": "Y",
                "inactive-value": "N",
                onChange: ($event: any) => (updateEnableFlagFn($event, scope.row.compCode))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "280",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewDetails(scope.row, 'edit')), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 修改 ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewDetails(scope.row, 'detail')), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 查看详情 ")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                link: "",
                type: "primary",
                size: "small",
                onClick: _withModifiers(($event: any) => (viewConfig(scope.row)), ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 租户配置 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        background: "",
        layout: "total, sizes, prev, pager, next",
        "page-sizes": pageSizes.value,
        total: total.value,
        "current-page": queryForm.pageIndex,
        "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.pageIndex) = $event)),
        "page-size": queryForm.pageSize,
        "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.pageSize) = $event)),
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogTitle.value,
      width: "40%",
      onClose: _cache[14] || (_cache[14] = ($event: any) => (handleClose(ruleFormRefBox.value, true))),
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (resetForm(ruleFormRefBox.value, true)))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取 消")
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (submitForm(ruleFormRefBox.value)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确 定 ")
            ]),
            _: 1
          }, 512), [
            [_vShow, dialogVisibleType.value != 'detail']
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          inline: true,
          "label-width": "120px",
          disabled: dialogVisibleType.value == 'detail',
          ref_key: "ruleFormRefBox",
          ref: ruleFormRefBox,
          model: _unref(ruleForm),
          rules: rules,
          class: "demo-ruleForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "租户代码",
                      prop: "compCode",
                      "label-width": "80px",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: dialogVisibleType.value == 'edit',
                          modelValue: _unref(ruleForm).compCode,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(ruleForm).compCode) = $event)),
                          maxlength: "50",
                          placeholder: "请输入租户代码"
                        }, null, 8, ["disabled", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "租户名称",
                      prop: "compName",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(ruleForm).compName,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(ruleForm).compName) = $event)),
                          maxlength: "10",
                          placeholder: "请输入租户名称"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "租户电话",
                      "label-width": "80px",
                      style: {"width":"100%"},
                      prop: "phone"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(ruleForm).phone,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(ruleForm).phone) = $event)),
                          maxlength: "11",
                          placeholder: "请输入租户电话"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "一级机构代码",
                      prop: "deptCode",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(ruleForm).deptCode,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(ruleForm).deptCode) = $event)),
                          type: "number",
                          maxlength: "50",
                          placeholder: "请输入一级机构代码"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      "label-width": "80px",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(ruleForm).remark,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(ruleForm).remark) = $event)),
                          type: "textarea",
                          rows: 2,
                          maxlength: "255",
                          placeholder: "请输入备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled", "model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: tenantConfigVisible.value,
      "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((tenantConfigVisible).value = $event)),
      title: "租户配置",
      width: "1000",
      "close-on-click-modal": false,
      "before-close": tenantConfigHandleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_98, [
          _createVNode(_component_el_button, { onClick: tenantConfigHandleClose }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: tenantConfigHandleConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确认 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event: any) => ((activeName).value = $event)),
          class: "demo-tabs",
          onTabClick: handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "验标采集配置",
              name: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form, {
                  ref_key: "ruleFormRefAll",
                  ref: ruleFormRefAll,
                  model: _unref(allForm),
                  class: "demo-ruleForm tenant-config1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { class: "left-form" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _hoisted_7,
                          _createVNode(_component_el_form, {
                            "label-width": "150px",
                            ref: "ruleFormRefConfig",
                            model: _unref(allForm).insureForm,
                            rules: rules,
                            class: "demo-ruleForm"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, { label: "承保验标对比范围：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _unref(allForm).insureForm.comparisonRangeObj.comparisonRange
                      ,
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(allForm).insureForm.comparisonRangeObj.comparisonRange
                      ) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio, {
                                        label: "CURRENT_ORDER_INSURE",
                                        value: "CURRENT_ORDER_INSURE",
                                        border: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("当前投保订单")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "标的相似度阈值：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _unref(allForm).insureForm.scoreObjList[0].score,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(allForm).insureForm.scoreObjList[0].score) = $event)),
                                    precision: 1,
                                    step: 0.1,
                                    max: 100,
                                    min: 0,
                                    controls: false
                                  }, null, 8, ["modelValue", "step"]),
                                  _createTextVNode("%")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "采集方式：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).insureForm.acquisitionTypeList,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(allForm).insureForm.acquisitionTypeList) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_checkbox, {
                                        label: "REAL_TIME_RECOGNITION",
                                        value: "REAL_TIME_RECOGNITION"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("实时识别")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_checkbox, {
                                        label: "VIDEO_RECOGNITION",
                                        value: "VIDEO_RECOGNITION"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("视频识别")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_checkbox, {
                                        label: "TAKE_PHOTO",
                                        value: "TAKE_PHOTO"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("拍照")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "承保验标订单来源：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).insureForm.sourceTypeList,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(allForm).insureForm.sourceTypeList) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_checkbox, {
                                        label: "APP_CREATE",
                                        value: "APP_CREATE"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("app新建")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_checkbox, {
                                        label: "SYSTEM_INTERGRATION_CREATE",
                                        value: "SYSTEM_INTERGRATION_CREATE"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("系统对接创建")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "采集部位配置：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).insureForm.selectedConfigs,
                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(allForm).insureForm.selectedConfigs) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allForm).insureForm
                        .acquisitionOptions, (config, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                          _createVNode(_component_el_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_col, { span: 24 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_checkbox, {
                                                    label: config.picTypeEnum,
                                                    value: config.picTypeEnum
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_8, _toDisplayString(getPicTypeDisplayText(config.picTypeEnum)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"]),
                                                  _createTextVNode(" 拍摄 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.shotNum,
                                                    "onUpdate:modelValue": ($event: any) => ((config.shotNum) = $event),
                                                    max: 5,
                                                    min: 1,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createTextVNode(" 张，默认阈值 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.defaultScore,
                                                    "onUpdate:modelValue": ($event: any) => ((config.defaultScore) = $event),
                                                    precision: 1,
                                                    step: 0.1,
                                                    max: 100,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                                                  _createTextVNode(" % ")
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_row, { class: "level-row" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_col, { span: 24 }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" 最小阈值 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.minScore,
                                                    "onUpdate:modelValue": ($event: any) => ((config.minScore) = $event),
                                                    precision: 1,
                                                    step: 0.1,
                                                    max: 100,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                                                  _createTextVNode(" %，手拍每次递减 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.degression,
                                                    "onUpdate:modelValue": ($event: any) => ((config.degression) = $event),
                                                    max: 100,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createTextVNode(" % ")
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_divider)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "采集字段：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).insureForm.selectedfields,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(allForm).insureForm.selectedfields) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insureCollectFields.value, (config, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                          _createVNode(_component_el_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_col, { span: 12 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_checkbox, {
                                                    label: config.field,
                                                    value: config.field
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_9, _toDisplayString(getCollectFieldText(config.field)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_el_col, { span: 12 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "是否必填：",
                                                    "label-width": "auto"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_switch, {
                                                        modelValue: config.isRequired,
                                                        "onUpdate:modelValue": ($event: any) => ((config.isRequired) = $event),
                                                        "inline-prompt": "",
                                                        "active-value": '1',
                                                        "inactive-value": '0',
                                                        "active-text": "是",
                                                        "inactive-text": "否"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "是否启用承保自动审核：",
                                "label-width": "auto"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _unref(allForm).insureForm.enableAutoCheck,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(allForm).insureForm.enableAutoCheck) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio, {
                                        label: getYes,
                                        value: getYes,
                                        border: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("是")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_radio, {
                                        label: getNo,
                                        value: getNo,
                                        border: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("否")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { class: "right-form" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _createVNode(_component_el_form, {
                            ref: "ruleFormRefConfig",
                            model: _unref(allForm).paymentForm,
                            rules: rules,
                            class: "demo-ruleForm",
                            "label-width": "150px"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "理赔验标对比范围：",
                                class: "range-radio"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _unref(allForm).paymentForm.comparisonRangeObj.comparisonRange
                      ,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(allForm).paymentForm.comparisonRangeObj.comparisonRange
                      ) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio, {
                                        label: "CURRENT_FARMER_CLAIM",
                                        value: "CURRENT_FARMER_CLAIM",
                                        border: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("当前农户")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_radio, {
                                        label: "POLICY_CLAIM",
                                        value: "POLICY_CLAIM",
                                        border: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("当前保单")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_radio, {
                                                class: "range-radio-item",
                                                label: "ORG_LEVEL_CLAIM",
                                                value: "ORG_LEVEL_CLAIM",
                                                border: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("按机构层级")
                                                ]),
                                                _: 1
                                              }),
                                              (
                            _unref(allForm).paymentForm.comparisonRangeObj
                              .comparisonRange === 'ORG_LEVEL_CLAIM'
                          )
                                                ? (_openBlock(), _createBlock(_component_el_input_number, {
                                                    key: 0,
                                                    modelValue: _unref(allForm).paymentForm.comparisonRangeObj.level
                            ,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(allForm).paymentForm.comparisonRangeObj.level
                            ) = $event)),
                                                    max: 100,
                                                    min: 1,
                                                    controls: false
                                                  }, null, 8, ["modelValue"]))
                                                : _createCommentVNode("", true),
                                              (
                            _unref(allForm).paymentForm.comparisonRangeObj
                              .comparisonRange === 'ORG_LEVEL_CLAIM'
                          )
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "级"))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "标的相似度阈值：" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 承保库"),
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _unref(allForm).paymentForm.scoreObjList[0].score,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(allForm).paymentForm.scoreObjList[0].score) = $event)),
                                    precision: 1,
                                    step: 0.1,
                                    max: 100,
                                    min: 0,
                                    controls: false
                                  }, null, 8, ["modelValue", "step"]),
                                  _createTextVNode("%，理赔库"),
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _unref(allForm).paymentForm.scoreObjList[1].score,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(allForm).paymentForm.scoreObjList[1].score) = $event)),
                                    precision: 1,
                                    step: 0.1,
                                    max: 100,
                                    min: 0,
                                    controls: false
                                  }, null, 8, ["modelValue", "step"]),
                                  _createTextVNode("% ")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "采集方式：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).paymentForm.acquisitionTypeList,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(allForm).paymentForm.acquisitionTypeList) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_checkbox, {
                                        label: "TAKE_PHOTO",
                                        value: "TAKE_PHOTO"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("拍照")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_checkbox, {
                                        label: "REAL_TIME_RECOGNITION",
                                        value: "REAL_TIME_RECOGNITION"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("实时识别")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_checkbox, {
                                        label: "VIDEO_RECOGNITION",
                                        value: "VIDEO_RECOGNITION"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("视频识别")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "理赔案件来源：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).paymentForm.sourceTypeList,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(allForm).paymentForm.sourceTypeList) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_checkbox, {
                                        label: "APP_CREATE",
                                        value: "APP_CREATE"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("app新建")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_checkbox, {
                                        label: "SYSTEM_INTERGRATION_CREATE",
                                        value: "SYSTEM_INTERGRATION_CREATE"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("系统对接创建")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "采集部位配置：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).paymentForm.selectedConfigs,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(allForm).paymentForm.selectedConfigs) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allForm).paymentForm
                        .acquisitionOptions, (config, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                          _createVNode(_component_el_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_col, { span: 24 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_checkbox, {
                                                    label: config.picTypeEnum,
                                                    value: config.picTypeEnum
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_13, _toDisplayString(getPicTypeDisplayText(config.picTypeEnum)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"]),
                                                  _createTextVNode(" 拍摄 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.shotNum,
                                                    "onUpdate:modelValue": ($event: any) => ((config.shotNum) = $event),
                                                    max: 5,
                                                    min: 1,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createTextVNode(" 张，默认阈值 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.defaultScore,
                                                    "onUpdate:modelValue": ($event: any) => ((config.defaultScore) = $event),
                                                    precision: 1,
                                                    step: 0.1,
                                                    max: 100,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                                                  _createTextVNode(" % ")
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_row, { class: "level-row" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_col, { span: 24 }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" 最小阈值 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.minScore,
                                                    "onUpdate:modelValue": ($event: any) => ((config.minScore) = $event),
                                                    precision: 1,
                                                    step: 0.1,
                                                    max: 100,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "step"]),
                                                  _createTextVNode(" %，手拍每次递减 "),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: config.degression,
                                                    "onUpdate:modelValue": ($event: any) => ((config.degression) = $event),
                                                    max: 100,
                                                    min: 0,
                                                    controls: false
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                  _createTextVNode(" % ")
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024),
                                          _createVNode(_component_el_divider)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, { label: "采集字段：" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_checkbox_group, {
                                    modelValue: _unref(allForm).paymentForm.selectedfields,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(allForm).paymentForm.selectedfields) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentCollectFields.value, (config, index) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                                          _createVNode(_component_el_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_col, { span: 12 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_checkbox, {
                                                    label: config.field,
                                                    value: config.field
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", _hoisted_14, _toDisplayString(getCollectFieldText(config.field)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["label", "value"])
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createVNode(_component_el_col, { span: 12 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "是否必填：",
                                                    "label-width": "auto"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_switch, {
                                                        modelValue: config.isRequired,
                                                        "onUpdate:modelValue": ($event: any) => ((config.isRequired) = $event),
                                                        "inline-prompt": "",
                                                        "active-value": '1',
                                                        "inactive-value": '0',
                                                        "active-text": "是",
                                                        "inactive-text": "否"
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["model", "rules"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"]),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "身份证校验：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(allForm).idCardVerification,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(allForm).idCardVerification) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: getYes,
                                  value: getYes,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("是")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, {
                                  label: getNo,
                                  value: getNo,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("否")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "手机号校验：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(allForm).phoneNumberVerification,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(allForm).phoneNumberVerification) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: getYes,
                                  value: getYes,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("是")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, {
                                  label: getNo,
                                  value: getNo,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("否")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "是否在APP端显示重复标的:" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(allForm).showRepeatTarget,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(allForm).showRepeatTarget) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: getYes,
                                  value: getYes,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("是")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, {
                                  label: getNo,
                                  value: getNo,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("否")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "是否允许疑似重复标的批量审核：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(allForm).allowRepeatBatchAudit,
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(allForm).allowRepeatBatchAudit) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: getYes,
                                  value: getYes,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("是")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, {
                                  label: getNo,
                                  value: getNo,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("否")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "验证耳标、项圈" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox_group, {
                              modelValue: _unref(allForm).verifyTargetOrCollar,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(allForm).verifyTargetOrCollar) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_checkbox, {
                                  label: eartag,
                                  value: eartag
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("耳标")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: collar,
                                  value: collar
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("项圈")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: never,
                                  value: never
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("自动生成")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_checkbox, {
                                  label: externalEarTag,
                                  value: externalEarTag
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("选择外部耳标号")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (
              Array.isArray(_unref(allForm).verifyTargetOrCollar) &&
              _unref(allForm).verifyTargetOrCollar.includes('NONE')
            )
                      ? (_openBlock(), _createBlock(_component_el_col, {
                          key: 0,
                          span: 12
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_form_item, { label: "耳标号生成规则" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_group, {
                                  modelValue: _unref(allForm).earTagGenerator,
                                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(allForm).earTagGenerator) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_radio, {
                                      label: timestamp,
                                      value: timestamp,
                                      border: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("时间戳")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_radio, {
                                      label: deptCode,
                                      value: deptCode,
                                      border: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("机构编码+序号")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { label: "是否启用模糊检测：" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: _unref(allForm).enableFuzzyCheck,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(allForm).enableFuzzyCheck) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio, {
                                  label: getYes,
                                  value: getYes,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("是")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio, {
                                  label: getNo,
                                  value: getNo,
                                  border: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("否")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "大模型配置（活活对比）",
              name: "2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_component_el_switch, {
                    modelValue: liveComparison.isEnabled,
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((liveComparison.isEnabled) = $event)),
                    "active-value": 1,
                    "inactive-value": 0
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createVNode(_component_el_select, {
                      modelValue: liveComparison.invokeModel,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((liveComparison.invokeModel) = $event)),
                      placeholder: "请选择",
                      style: {"width":"120px"},
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "openAI",
                          value: "openAI"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ], 512), [
                    [_vShow, liveComparison.isEnabled]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_el_input, {
                        modelValue: liveComparison.companySimilarityPre,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((liveComparison.companySimilarityPre) = $event)),
                        style: {"width":"80px"},
                        max: 100,
                        min: 0,
                        type: "number",
                        onBlur: _cache[40] || (_cache[40] = ($event: any) => (
                    modelSimilarOnBlur(liveComparison, 'companySimilarityPre')
                    ))
                      }, null, 8, ["modelValue"]),
                      _createTextVNode(" % — "),
                      _createVNode(_component_el_input, {
                        modelValue: liveComparison.companySimilarityPost,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((liveComparison.companySimilarityPost) = $event)),
                        style: {"width":"80px"},
                        max: 100,
                        min: 0,
                        type: "number",
                        onBlur: _cache[42] || (_cache[42] = ($event: any) => (
                    modelSimilarOnBlur(liveComparison, 'companySimilarityPost')
                    ))
                      }, null, 8, ["modelValue"]),
                      _createTextVNode(" % ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_el_input, {
                        modelValue: liveComparison.modelPromptWord,
                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((liveComparison.modelPromptWord) = $event)),
                        style: {"width":"100%"},
                        rows: 8,
                        type: "textarea",
                        maxlength: 3000
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(liveComparison.largeModelConditions, (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_el_tag, {
                              type: "primary",
                              effect: "dark",
                              class: "condition"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("条件" + _toDisplayString(index === 0 ? "一" : "二"), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("span", _hoisted_31, "大模型相似度 " + _toDisplayString(index === 0
                            ? `  <  `
                            : "  >=  "), 1),
                              _createVNode(_component_el_input, {
                                modelValue: item.largeModelSimilarity,
                                "onUpdate:modelValue": ($event: any) => ((item.largeModelSimilarity) = $event),
                                modelModifiers: { number: true },
                                style: {"width":"80px"},
                                max: 100,
                                min: 0,
                                onBlur: _cache[44] || (_cache[44] = ($event: any) => (
                          modelSimilarConditionOnBlur($event, liveComparison)
                          ))
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              _hoisted_35,
                              _createVNode(_component_el_input, {
                                modelValue: item.largeModelSimilarityProp,
                                "onUpdate:modelValue": ($event: any) => ((item.largeModelSimilarityProp) = $event),
                                style: {"width":"80px"},
                                onBlur: ($event: any) => (
                        modelSimilarCalcOnBlur(
                          $event,
                          liveComparison,
                          index,
                          'largeModelSimilarityProp'
                        )
                        )
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                              _hoisted_36,
                              _createVNode(_component_el_input, {
                                modelValue: item.companySimilarityProp,
                                "onUpdate:modelValue": ($event: any) => ((item.companySimilarityProp) = $event),
                                style: {"width":"80px"},
                                onBlur: ($event: any) => (
                        modelSimilarCalcOnBlur(
                          $event,
                          liveComparison,
                          index,
                          'companySimilarityProp'
                        )
                        )
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                            ])
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ], 512), [
                  [_vShow, liveComparison.isEnabled]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "大模型配置（活死对比）",
              name: "3"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_el_switch, {
                    modelValue: lifeDeathComparison.isEnabled,
                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((lifeDeathComparison.isEnabled) = $event)),
                    "active-value": 1,
                    "inactive-value": 0
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createVNode(_component_el_select, {
                      modelValue: lifeDeathComparison.invokeModel,
                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((lifeDeathComparison.invokeModel) = $event)),
                      placeholder: "请选择",
                      style: {"width":"120px"},
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "openAI",
                          value: "openAI"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ], 512), [
                    [_vShow, lifeDeathComparison.isEnabled]
                  ])
                ]),
                _withDirectives(_createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_el_input, {
                        modelValue: lifeDeathComparison.companySimilarityPre,
                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((lifeDeathComparison.companySimilarityPre) = $event)),
                        style: {"width":"80px"},
                        max: 100,
                        min: 0,
                        type: "number",
                        onBlur: _cache[48] || (_cache[48] = ($event: any) => (
                    modelSimilarOnBlur(
                      lifeDeathComparison,
                      'companySimilarityPre'
                    )
                    ))
                      }, null, 8, ["modelValue"]),
                      _createTextVNode(" % — "),
                      _createVNode(_component_el_input, {
                        modelValue: lifeDeathComparison.companySimilarityPost,
                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((lifeDeathComparison.companySimilarityPost) = $event)),
                        style: {"width":"80px"},
                        max: 100,
                        min: 0,
                        type: "number",
                        onBlur: _cache[50] || (_cache[50] = ($event: any) => (
                    modelSimilarOnBlur(
                      lifeDeathComparison,
                      'companySimilarityPost'
                    )
                    ))
                      }, null, 8, ["modelValue"]),
                      _createTextVNode(" % ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_el_input, {
                        modelValue: lifeDeathComparison.modelPromptWord,
                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((lifeDeathComparison.modelPromptWord) = $event)),
                        style: {"width":"100%"},
                        rows: 8,
                        type: "textarea",
                        maxlength: 3000
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _createElementVNode("div", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lifeDeathComparison.largeModelConditions, (item, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_el_tag, {
                              type: "primary",
                              effect: "dark",
                              class: "condition"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("条件" + _toDisplayString(index === 0 ? "一" : "二"), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("span", _hoisted_53, "大模型相似度 " + _toDisplayString(index === 0
                            ? `  <  `
                            : "  >=  "), 1),
                              _createVNode(_component_el_input, {
                                modelValue: item.largeModelSimilarity,
                                "onUpdate:modelValue": ($event: any) => ((item.largeModelSimilarity) = $event),
                                modelModifiers: { number: true },
                                style: {"width":"80px"},
                                max: 100,
                                min: 0,
                                onBlur: _cache[52] || (_cache[52] = ($event: any) => (
                          modelSimilarConditionOnBlur(
                            $event,
                            lifeDeathComparison
                          )
                          ))
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _hoisted_55,
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createVNode(_component_el_input, {
                                modelValue: item.largeModelSimilarityProp,
                                "onUpdate:modelValue": ($event: any) => ((item.largeModelSimilarityProp) = $event),
                                style: {"width":"80px"},
                                onBlur: ($event: any) => (
                        modelSimilarCalcOnBlur(
                          $event,
                          lifeDeathComparison,
                          index,
                          'largeModelSimilarityProp'
                        )
                        )
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                              _hoisted_58,
                              _createVNode(_component_el_input, {
                                modelValue: item.companySimilarityProp,
                                "onUpdate:modelValue": ($event: any) => ((item.companySimilarityProp) = $event),
                                style: {"width":"80px"},
                                onBlur: ($event: any) => (
                        modelSimilarCalcOnBlur(
                          $event,
                          lifeDeathComparison,
                          index,
                          'companySimilarityProp'
                        )
                        )
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                            ])
                          ])
                        ], 64))
                      }), 128))
                    ])
                  ])
                ], 512), [
                  [_vShow, lifeDeathComparison.isEnabled]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "数据推送",
              name: "4"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: insurancePushConfig.enable,
                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((insurancePushConfig.enable) = $event)),
                        "true-label": YES_1,
                        "false-label": NO_0,
                        disabled: insuranceApiOptions.value.length === 0,
                        onChange: _cache[54] || (_cache[54] = ($event: any) => (handleConfigToggle('insurance')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_62
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['push-content', { 'is-hidden': insurancePushConfig.enable !== YES_1 }]),
                        style: _normalizeStyle({
              display: insurancePushConfig.enable === YES_1 ? 'block' : 'none',
              opacity: insurancePushConfig.enable === YES_1 ? 1 : 0,
              height: insurancePushConfig.enable === YES_1 ? 'auto' : '0',
              overflow: insurancePushConfig.enable === YES_1 ? 'visible' : 'hidden',
              transition: 'all 0.3s ease'
            })
                      }, [
                        (insuranceApiOptions.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                              _createVNode(_component_el_select, {
                                modelValue: insurancePushConfig.apiValue,
                                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((insurancePushConfig.apiValue) = $event)),
                                disabled: insuranceApiOptions.value.length === 0,
                                placeholder: "请选择推送接口",
                                onChange: _cache[56] || (_cache[56] = ($event: any) => (handleApiSelect('insurance', $event))),
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insuranceApiOptions.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: `insurance-${item.apiValue}`,
                                      label: item.apiName,
                                      value: item.apiValue
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _createVNode(_component_el_alert, {
                                type: "warning",
                                title: "暂无可用推送接口",
                                closable: false,
                                "show-icon": ""
                              })
                            ])),
                        (insurancePushConfig.apiValue)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_66, [
                                _hoisted_67,
                                _createVNode(_component_el_radio_group, {
                                  modelValue: insurancePushConfig.targetRange,
                                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((insurancePushConfig.targetRange) = $event)),
                                  class: "radio-group"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurancePushConfig.targetRangeOptions, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_radio, {
                                        key: `insurance-range-${option.value}`,
                                        label: option.value,
                                        class: "radio-item"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_68, [
                                _hoisted_69,
                                _createVNode(_component_el_checkbox_group, {
                                  modelValue: insurancePushConfig.modeList,
                                  "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((insurancePushConfig.modeList) = $event)),
                                  class: "checkbox-group"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurancePushConfig.modeOptions, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                                        key: `insurance-mode-${option.value}`,
                                        label: String(option.value),
                                        class: "checkbox-item"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 6)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: claimPushConfig.enable,
                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((claimPushConfig.enable) = $event)),
                        "true-label": YES_1,
                        "false-label": NO_0,
                        disabled: claimApiOptions.value.length === 0,
                        onChange: _cache[60] || (_cache[60] = ($event: any) => (handleConfigToggle('claim')))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_72
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['push-content', { 'is-hidden': claimPushConfig.enable !== YES_1 }]),
                        style: _normalizeStyle({
              display: claimPushConfig.enable === YES_1 ? 'block' : 'none',
              opacity: claimPushConfig.enable === YES_1 ? 1 : 0,
              height: claimPushConfig.enable === YES_1 ? 'auto' : '0',
              overflow: claimPushConfig.enable === YES_1 ? 'visible' : 'hidden',
              transition: 'all 0.3s ease'
            })
                      }, [
                        (claimApiOptions.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                              _createVNode(_component_el_select, {
                                modelValue: claimPushConfig.apiValue,
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((claimPushConfig.apiValue) = $event)),
                                disabled: claimApiOptions.value.length === 0,
                                placeholder: "请选择推送接口",
                                onChange: _cache[62] || (_cache[62] = ($event: any) => (handleApiSelect('claim', $event))),
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(claimApiOptions.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: `claim-${item.apiValue}`,
                                      label: item.apiName,
                                      value: item.apiValue
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled"])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                              _createVNode(_component_el_alert, {
                                type: "warning",
                                title: "暂无可用推送接口",
                                closable: false,
                                "show-icon": ""
                              })
                            ])),
                        (claimPushConfig.apiValue)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_76, [
                                _hoisted_77,
                                _createVNode(_component_el_radio_group, {
                                  modelValue: claimPushConfig.targetRange,
                                  "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((claimPushConfig.targetRange) = $event)),
                                  class: "radio-group"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(claimPushConfig.targetRangeOptions, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_radio, {
                                        key: `claim-range-${option.value}`,
                                        label: option.value,
                                        class: "radio-item"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createVNode(_component_el_checkbox_group, {
                                  modelValue: claimPushConfig.modeList,
                                  "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((claimPushConfig.modeList) = $event)),
                                  class: "checkbox-group"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(claimPushConfig.modeOptions, (option) => {
                                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                                        key: `claim-mode-${option.value}`,
                                        label: String(option.value),
                                        class: "checkbox-item"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(option.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["label"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 6)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "图片水印",
              name: "5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: insuranceWaterConfig.enable,
                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((insuranceWaterConfig.enable) = $event)),
                        "true-label": YES_1,
                        "false-label": NO_0,
                        onChange: handleInsuranceWaterEnableChange
                      }, {
                        default: _withCtx(() => [
                          _hoisted_83
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_84, [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: insuranceWaterConfig.configOptionList,
                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((insuranceWaterConfig.configOptionList) = $event)),
                        style: {"width":"80%"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_85, [
                            _createVNode(_component_el_checkbox, { label: "businessEntity" }, {
                              default: _withCtx(() => [
                                _createTextVNode("经营主体")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "businessCode" }, {
                              default: _withCtx(() => [
                                _createTextVNode("经营主体代码")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "orderNo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标订单号")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_86, [
                            _createVNode(_component_el_checkbox, { label: "insuranceType" }, {
                              default: _withCtx(() => [
                                _createTextVNode("投保险种")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "targetNo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("标的编号")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "registrationNo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("登记号")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _createVNode(_component_el_checkbox, { label: "location" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标位置")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "gps" }, {
                              default: _withCtx(() => [
                                _createTextVNode("GPS")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "inspector" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标人")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _createVNode(_component_el_checkbox, { label: "time" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标时间")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "result" }, {
                              default: _withCtx(() => [
                                _createTextVNode("承保验标结果")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "logo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("LOGO")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_upload, {
                        class: _normalizeClass(fileList.value.length > 0 ? 'upload-empty' : 'upload'),
                        "file-list": fileList.value,
                        "onUpdate:file-list": _cache[67] || (_cache[67] = ($event: any) => ((fileList).value = $event)),
                        "on-remove": (file, fileList) => handleremove('LOGO', file, fileList)
                    ,
                        action: '',
                        limit: 1,
                        "http-request": uploadRequestFactory('LOGO'),
                        "list-type": "picture-card",
                        "on-preview": handlePictureCardPreview
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Plus)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class", "file-list", "on-remove", "http-request"])
                    ], 512), [
                      [_vShow, insuranceWaterConfig.enable === YES_1]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("div", _hoisted_90, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: claimWaterConfig.enable,
                        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((claimWaterConfig.enable) = $event)),
                        "true-label": YES_1,
                        "false-label": NO_0,
                        onChange: handleClaimWaterEnableChange
                      }, {
                        default: _withCtx(() => [
                          _hoisted_91
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_92, [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: claimWaterConfig.configOptionList,
                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((claimWaterConfig.configOptionList) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_93, [
                            _createVNode(_component_el_checkbox, { label: "businessEntity" }, {
                              default: _withCtx(() => [
                                _createTextVNode("经营主体")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "businessCode" }, {
                              default: _withCtx(() => [
                                _createTextVNode("经营主体代码")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "caseNo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("案件号")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(_component_el_checkbox, { label: "insuranceType" }, {
                              default: _withCtx(() => [
                                _createTextVNode("投保险种")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "targetNo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("标的编号")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "registrationNo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("登记号")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_95, [
                            _createVNode(_component_el_checkbox, { label: "location" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标位置")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "gps" }, {
                              default: _withCtx(() => [
                                _createTextVNode("GPS")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "inspector" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标人")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_el_checkbox, { label: "time" }, {
                              default: _withCtx(() => [
                                _createTextVNode("验标时间")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "comparisonResult" }, {
                              default: _withCtx(() => [
                                _createTextVNode("投保对比结果")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_checkbox, { label: "claimComparisonResult" }, {
                              default: _withCtx(() => [
                                _createTextVNode("理赔对比结果")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_97, [
                            _createVNode(_component_el_checkbox, { label: "logo" }, {
                              default: _withCtx(() => [
                                _createTextVNode("LOGO")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ], 512), [
                      [_vShow, claimWaterConfig.enable === YES_1]
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisibleImage.value,
      "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((dialogVisibleImage).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("img", {
            src: dialogImageUrl.value,
            alt: "Preview Image"
          }, null, 8, _hoisted_100)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})